import { WidgetComponent } from "../widget.component";
import { WIDGET_CUSTOM } from "@shared/models/widget";
import { Component, ChangeDetectionStrategy } from "@angular/core";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { LogService } from "@shared/services/log.service";
import { ConfigScreenWidgetComponent } from "../config-screen/config-screen.widget.component";
import { FieldComponent } from "../../../elements/field/field.component";

@Component({
    templateUrl: "custom.widget.component.html",
    styleUrls: ["custom.widget.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ConfigScreenWidgetComponent, FieldComponent, TranslatePipe]
})
export class CustomWidgetConfigComponent extends WidgetComponent {
    constructor(public translate: TranslateService, logService: LogService) {
        super(WIDGET_CUSTOM, "Custom Widget", translate, logService, "generic");
    }
}
